import type { PointOfInterest } from "../../@types/mapviewxs";
import type { WatchListEntries } from "../map/types";

export interface Input {
  pointsOfInterest: PointOfInterest[] | undefined;
  watchListItems?: WatchListEntries;
  handleWatchListItemToggle?: (listingId: string) => void;
}

interface State {
  shouldUpdateCarousel: boolean;
}

export default class extends Marko.Component<Input, State> {
  declare previousPOIs?: PointOfInterest[];

  onCreate() {
    this.state = {
      shouldUpdateCarousel: true,
    };
  }

  onInput(input: Input) {
    const previousPOIs = this.previousPOIs;
    const currentPOIs = input.pointsOfInterest;

    this.previousPOIs = currentPOIs;
    this.state.shouldUpdateCarousel = this.hasPointsOfInterestChanged(currentPOIs, previousPOIs);
  }

  hasPointsOfInterestChanged(current?: PointOfInterest[], previous?: PointOfInterest[]): boolean {
    if (current?.length !== previous?.length) {
      return true;
    }

    return !current?.every((poi, index) => poi.itemCard?.card?.listingId === previous?.[index]?.itemCard?.card?.listingId);
  }
}
